/**
 * 
 * key
 * 
 */


const key = 'bW9udGhXaXNlQ2xpZW50Q2xvc3VyZVJlcG9ydA=='

export default key 